/**
 * MG Time Tracker Application
 *	WorkingHoursModal.js
 */

import React, { Component } from "react";
import Loader from "react-loader-advanced";
import HoursItem from "./ModalListItems/HoursItem";
import CloseButton from "./CloseButton";
import { connect } from "react-redux";
import { refreshEntries } from "../../actions/historyActions";
import loaderSettings from "../../styles/loaderSettings";
import sentry from "../../utils/sentry";

// Component Imports

// SASS Imports
require("./Modal.scss");

function mapStateToProps(state, ownProps) {
  return {
    workingHours: state.settings.workingHours,
    api: state.api,
    settings: state.settings
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onSaveWorkingHours: async function(newWorkingHours) {
      await dispatch({ type: "SET_WORKING_HOURS", days: newWorkingHours });
      await dispatch(refreshEntries());
    },
  };
}

class WorkingHoursModal extends Component {
  constructor(props){
    super(props);
    let days = ["MON","TUE","WED","THU","FRI","SAT","SUN"];
    this.state = {
      workingHours: this.props.workingHours.map((x, i) => ({ ...x, day: days[i] })),
      loading: false
    };
  }

  changeCheckBoxDay(i){
    let workingHours = this.state.workingHours.slice();
    workingHours[i].enabled = ! workingHours[i].enabled;
    this.setState({updated:true, workingHours});
  }

  changeHoursInput(i, hours){
    let workingHours = this.state.workingHours.slice();
    workingHours[i].workingHours = hours;
    this.setState({updated:true, workingHours});
  }

  saveSettings() {
    const newWorkingHours = this.state.workingHours.map(x => {
      return {
        enabled: x.enabled,
        workingHours: Number(x.workingHours).toFixed(1).toString()
      };
    });

    const newSettings = { ...this.props.settings, workingHours: newWorkingHours };

    this.setState({ loading: true });

    this.props.api.saveUserPreferences(newSettings)
      .then(async () => {
        await this.props.onSaveWorkingHours(newWorkingHours);

        this.setState({ loading: false });

        if (typeof this.props.nextStep === "function") {
          this.props.nextStep();
        } else if (typeof this.props.closeModal === "function") {
          this.props.closeModal();
        }
      })
      .catch((error) => {
        sentry.logException(error);
        this.setState({ loading: false });
      });
  }

  render() {
    var workWeek = this.state.workingHours.slice(0,5);
    var weekend = this.state.workingHours.slice(-2);

    var workWeekList = workWeek.map((day, i) => {
      return <HoursItem key={`day${i}`} day={ day.day } enabled={ day.enabled } hours={ day.workingHours } checkboxSwitch={ () => { this.changeCheckBoxDay(i); } } changeHoursInput={hours => this.changeHoursInput(i, hours)} />;
    });

    var weekendList = weekend.map((day, i) => {
      return <HoursItem key={`day${i+5}`} day={ day.day } enabled={ day.enabled } hours={ day.workingHours } checkboxSwitch={ () => { this.changeCheckBoxDay(i+5); } } changeHoursInput={hours => this.changeHoursInput(i+5, hours)} />;
    });

    return (
      <div className="modalPanel defaultModal">
        {this.props.closeModal?
          <button className="close" onClick={ this.props.closeModal }>
            <CloseButton />
          </button>:null}
        <div className="modalWrap">
          {this.props.closeModal?
            <div className="modalHeader text-center">
              <h4>Edit Working Hours</h4>
            </div> :
            <div className="modalHeader text-center">
              <h4>Confirm Working Hours</h4>
            </div>}

          <Loader show={this.state.loading} {...loaderSettings} message={'saving...'}>
            <div className="modalContent">

              <div className="container-fluid hoursItems">
                <div className="row">
                  <div className="col-sm-6 col-xs-12">
                    { workWeekList }
                  </div>
                  <div className="col-sm-6 col-xs-12">
                    { weekendList }
                  </div>
                </div>
                {this.props.closeModal ?
                  <div className="row">
                    <div className="saveButton col-sm-4 col-xs-6 col-sm-offset-2">
                      <button className="btn-delete" onClick={ this.props.closeModal }>Cancel</button>
                    </div>
                    <div className="saveButton col-sm-4 col-xs-6">
                      <button className="btn-submit" onClick={ () => { this.saveSettings(); } }>Save</button>
                    </div>
                  </div> :
                  <div className="row">
                    <div className="saveButton col-sm-4 col-xs-6 col-sm-offset-4 col-xs-offset-3">
                      <button className="btn-submit" onClick={ () => { this.saveSettings(); } }>Continue</button>
                    </div>
                  </div>
                }
              </div>

            </div>
          </Loader>
        </div>

      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkingHoursModal);



// WEBPACK FOOTER //
// ./app/components/Modals/WorkingHoursModal.jsx